import { render, staticRenderFns } from "./disclosure_data_table.vue?vue&type=template&id=c39f2f18"
import script from "./disclosure_data_table.vue?vue&type=script&lang=js"
export * from "./disclosure_data_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports